var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-page"},[_c('loading',{attrs:{"color":"#007bff","width":100,"height":100,"active":_vm.isPageLoading},on:{"update:active":function($event){_vm.isPageLoading=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }